import { lerpHex, lerpMultipleColors } from '../../utils/colorUtils';
import { defaultFormatValue } from '../../utils/formatUtils';
import { polarToCartesian } from '../../utils/geometryUtils';

export { defaultFormatValue, lerpHex, lerpMultipleColors, polarToCartesian };

export const prefersReducedMotion = (): boolean =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const easeOut = (t: number): number => 1 - (1 - t) ** 2;

export const getCSSVariableValue = (
  variableName: string,
  fallback = '#000000'
): string => {
  if (typeof window === 'undefined') {
    return fallback; // SSR safety
  }

  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim();

  return value || fallback;
};
